
import Vue from "vue";

const LocationAPIService = class extends Vue {
  _DEBUG = false;

  constructor() {
    super();
    if (this._DEBUG) {
      this.debugMessage('BOOTSTRAPPED LOCATION API SERVICE');
    }
  }

  debugMessage(message) {
    if (this._DEBUG) {
      console.log(message);
    }
  }

  async fetchLocations(query = { tenantName: null, limit: 30, skip: 0 }) {
    if (query.tenantName && config) {   
        const claims = await this.$auth.getIdTokenClaims();
        const id_token = claims.__raw;
        const url = `${config.API_GATEWAY}/location/userLocations?${new URLSearchParams(query).toString()}`;
        const request = new Request(url, {
            method: "GET",
            mode: "cors",
            cache: "default",
            withCredentials: true,
            headers: {
              Authorization: "Bearer " + id_token,
              "Content-Type": "application/json",
            },
        });
        try {
            const response = await fetch(request);
            if (response.status === 403) {
              return;
            }
            if (response.status == 401) {
              return;
            }
            if (response.status == 503) {
              return this.fetchLocations(query);
            }
            if (response.status != 200) {
                return;
            } else {
              const data = await response.json();
              return data;
            }
        } catch (dex) {
            console.error("failed to get devices", dex);
        }
    }
  }
};

// Singleton Pattern Instantiate
if (!Vue.prototype.$LocationAPIService) {
  Vue.prototype.$LocationAPIService = new LocationAPIService();
}

export default Vue.prototype.$LocationAPIService;
